import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const ButtonContainer = styled('div')<{
    isDisabled?: boolean
    theme?: TTheme
}>`
    display: flex;
    align-items: center;
    gap: 10px;
    color: ${({ isDisabled, theme }) =>
        isDisabled ? theme.colors.greys[500] : 'var(--color-primary)'};
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

    .icon {
        background-color: ${({ isDisabled, theme }) =>
            isDisabled ? theme.colors.greys[500] : 'var(--color-primary)'};
        padding: 6px;
        border-radius: 50%;
        color: ${({ theme }) => theme.colors.greys[0]};
    }
`
